import { post, get, put, del } from '../axiosconfig'

import qs from 'qs';
export default {
  // 新闻列表
  chatHot(params) {
    return post('/zsc/web/console/colly/hot',params)
  },
  // 新闻详情
  chatHotNew(params) {
    return post('/zsc/web/console/colly/hot/new',params)
  },
  // 创作记录
  chatList(params) {
    return post('/zsc/web/console/colly/write/list',params)
  },
  // 记录详情
  chatLog(params) {
    return post('/zsc/web/console/colly/write/log',params)
  },
  // 提问推荐
  chatRecommend(params) {
    return post('/zsc/web/console/colly/write/recommend',params)
  },
  // 发起提问
  chatCreate(params) {
    // params = qs.stringify(params)
    return postStream('/zsc/web/console/colly/write/create', params)
  },

}



// WEBPACK FOOTER //
// ./src/api/public/chat_api.js